import { useFlags } from "launchdarkly-react-client-sdk";
import { MctFlags } from "./types";

export function useMctFlags() {
  return useFlags() as MctFlags;
}
